import { useConfirmation } from "components/dialog/confirmation";
import toast from "react-hot-toast";
import Card from "components/card";
import { handleAxiosAndCaughtError } from "utils";
import { useRoleInfo } from "layouts/role-info/_context/RoleinfoContext";
import { useTranslation } from "react-i18next";

const Setting = () => {
  const { t } = useTranslation();
  const { roleInfo, deactivateRole, activateRole } = useRoleInfo();
  const { confirm } = useConfirmation();
  const handleDeactivate = async () => {
    const confirmed = await confirm({
      title: t("roles.settings.deactivateRole"),
      message: t("roles.settings.confirmDeactivateRole"),
      confirmText: t("roles.settings.deactivate"),
      cancelText: t("common.cancel"),
      variant: "danger",
    });
    if (confirmed) {
      try {
        await deactivateRole();
      } catch (err) {
        handleAxiosAndCaughtError(err);
      }
    }
  };
  const handleActivate = async () => {
    const confirmed = await confirm({
      title: t("roles.settings.activateRole"),
      message: t("roles.settings.confirmActivateRole"),
      confirmText: t("roles.settings.activate"),
      cancelText: t("common.cancel"),
      variant: "danger",
    });
    if (confirmed) {
      try {
        await activateRole();
      } catch (err) {
        handleAxiosAndCaughtError(err);
      }
    }
  };
  return (
    <div className="mt-3 flex w-full flex-col  gap-5 rounded-[20px]     ">
      <div className="w-full max-w-xl">
        {roleInfo?.is_active ? (
          <Card extra="flex flex-col gap-4 sm:!flex-row py-6 px-4 sm:px-[30px] justify-between items-start sm:items-center w-full">
            <div className="w-full sm:w-auto">
              <h3 className="mb-px text-xl font-bold text-navy-700 dark:text-white">
                {t("roles.settings.deactivateRoleTitle")}
              </h3>
              <p className="text-base text-gray-600">
                {t("roles.settings.deactivateRoleDescription")}
              </p>
            </div>
            <button
              onClick={handleDeactivate}
              className="linear mt-2 flex w-full cursor-pointer items-center justify-center rounded-xl border border-red-500 px-4 py-2 text-base font-medium text-red-500 transition duration-200 hover:bg-red-50 active:bg-red-100 dark:active:bg-red-50 dark:active:opacity-80 sm:mt-0 sm:w-auto"
            >
              {t("roles.settings.deactivateRole")}
            </button>
          </Card>
        ) : (
          <Card extra="flex flex-col gap-4 sm:!flex-row py-6 px-4 sm:px-[30px] justify-between items-start sm:items-center w-full">
            <div className="w-full sm:w-auto">
              <h3 className="mb-px text-xl font-bold text-navy-700 dark:text-white">
                {t("roles.settings.activateRoleTitle")}
              </h3>
              <p className="text-base text-gray-600">
                {t("roles.settings.activateRoleDescription")}
              </p>
            </div>
            <button
              onClick={handleActivate}
              className="linear mt-2 flex w-full cursor-pointer items-center justify-center rounded-xl border border-red-500 px-4 py-2 text-base font-medium text-red-500 transition duration-200 hover:bg-red-50 active:bg-red-100 dark:active:bg-red-50 dark:active:opacity-80 sm:mt-0 sm:w-auto"
            >
              {t("roles.settings.activateRole")}
            </button>
          </Card>
        )}
      </div>
    </div>
  );
};

export default Setting;
